import React from 'react';
import { useLocation } from 'react-router-dom';
export function useQuerySearch() {
    var search = useLocation().search;
    return React.useMemo(function () { return new URLSearchParams(search); }, [search]);
}
